import React, { useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';

interface FilePreviewModalProps {
  visible: boolean;
  url: string | null;
  onClose: () => void;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({ visible, url, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);

  const extension = url?.split('.').pop()?.toLowerCase();
  const isPDF = extension === 'pdf';
  const previewType = isPDF ? 'pdf' : 'image';

  // When modal opens or URL changes, reset loading
  useEffect(() => {
    if (visible && url) {
      setLoading(true);
      setCurrentUrl(url); // trigger rerender with new image
    }
  }, [visible, url]);

  const handleLoad = () => setLoading(false);

  if (!url) return null;

  return (
    <Modal
      open={visible}
      footer={null}
      centered
      onCancel={() => {
        setLoading(true);
        onClose();
      }}
      width={isPDF ? '80%' : '600px'}
      bodyStyle={{ padding: 0, position: 'relative', minHeight: '50vh' }}
    >
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
          <Spin size="large" />
        </div>
      )}

      {previewType === 'image' && currentUrl && (
        <img
          key={currentUrl} // force rerender on URL change
          src={currentUrl}
          alt="Image Preview"
          onLoad={handleLoad}
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            maxHeight: '80vh',
            opacity: loading ? 0 : 1,
            transition: 'opacity 0.2s ease-in-out',
          }}
        />
      )}

      {previewType === 'pdf' && currentUrl && (
        <iframe
          key={currentUrl}
          src={currentUrl}
          title="PDF Preview"
          onLoad={handleLoad}
          style={{
            width: '100%',
            height: '80vh',
            border: 'none',
            display: loading ? 'none' : 'block',
          }}
        />
      )}
    </Modal>
  );
};

export default FilePreviewModal;
